import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Row as AntRow } from "antd";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import Table from "../../Components/TableTemplate/Table";
import {
  dateFormat,
  formatDate,
  getRestoLogin,
  getRole,
  numberFormat,
  numberWithCommas,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import toast from "react-hot-toast";
import ExportPDF from "../../Components/Export/ExportPDF";
import { useReactToPrint } from "react-to-print";
import PrintReportReceipts from "../../Components/Print/PrintReportReceipts";
import Pdf from "react-to-pdf";
import { DownloadTableExcel } from "react-export-table-to-excel";
import html2canvas from "html2canvas";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import imageCompression from "compressorjs";

const ref = React.createRef();
const ref2 = React.createRef();

function ItemHistory() {
  const [inactive, setInactive] = useState(true);
  const [itemHistory, setItemHistory] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const componentRef = useRef();
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    performing: "",
  });
  const [exportData, setExportData] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [priceTotal, setPriceTotal] = useState(0);

  const headers = ["Menu Name", "Count", "Price", "Total"];

  async function fetchSales() {
    setShowLoader(true);
    const response = await UseGetRequest(
      "reports/itemHistory",
      filter,
      getRestoLogin()
    );
    if (response.data) {
      let result = [];
      result = response.data.data.histories.map((data) => {
        return {
          menu_name: data.menu_name,
          count: data.count,
          price: data.price,
          total: numberWithCommas(data.total),
        };
      });
      setGrandTotal(
        result
          .map((data) => parseFloat(data.total))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setPriceTotal(
        result
          .map((data) => parseFloat(data.price))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );

      if (filter.performing === "top") {
        setItemHistory(
          result.length === 0
            ? []
            : result.sort(({ count: a }, { count: b }) => b - a)
        );
        setExportData(
          result.length === 0
            ? []
            : result.sort(({ count: a }, { count: b }) => b - a)
        );
      } else if (filter.performing === "worst") {
        setItemHistory(
          result.length === 0
            ? []
            : result.sort(({ count: a }, { count: b }) => a - b)
        );
        setExportData(
          result.length === 0
            ? []
            : result.sort(({ count: a }, { count: b }) => a - b)
        );
      } else {
        setItemHistory(result.length === 0 ? [] : result);
        setExportData(result.length === 0 ? [] : result);
      }
    }
    setShowLoader(false);
  }

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Item Report Summary"
        sheet="users"
        currentTableRef={componentRef.current}
      >
        <button className="category-new-export-btn w-100">Export to CSV</button>
      </DownloadTableExcel>
    );
  }

  const componentRefSummary = useRef();
  const handlePrintReport = useReactToPrint({
    content: () => componentRefSummary.current,
    pageStyle: () => "@page { size: letter; margin: 5mm; }",
  });

  function handlePDF() {
    return (
      <ExportPDF
        name={
          filter.performing === ""
            ? "Item History - All"
            : filter.performing === "top"
            ? "Item History - Top"
            : "Item History - Worst"
        }
        date={filter}
        data={exportData}
        header={headers}
        report={"item-history"}
      >
        <Pdf
          targetRef={exportData ? ref2 : ref}
          filename={"officialReceipt_" + formatDate(new Date()) + ".pdf"}
          style={{ height: "100%", width: "100%" }}
        >
          {({ toPdf }) => (
            <button
              className="category-new-export-btn"
              onClick={handlePrintReport}
            >
              Export to PDF
            </button>
          )}
        </Pdf>
      </ExportPDF>
    );
  }

  const divId = useRef(null);
  const [allowPrint, setAllowPrint] = useState(false);
  // const handlePrint = () => {
  //   setAllowPrint(true)
  // }
  const handleGeneratePrint = () => {
    // setAllowPrint(true)
    if (divId.current) {
      const element = divId.current;

      // element.style.width = "40%";
      // element.style.height = "100%";
      html2canvas(element, { scale: 1 }).then((canvas) => {
        canvas.toBlob((blob) => {
          new imageCompression(blob, {
            quality: 0.6,
            maxWidth: 2024,
            // maxHeight: 1024,
            success(compressedResult) {
              const reader = new FileReader();
              reader.readAsDataURL(compressedResult);
              reader.onloadend = () => {
                const compressedBase64 = reader.result;
                // Pass the compressed Base64 image to the printBase64Data function
                printBase64Data(compressedBase64);
                toast.success("Processing...", {
                  style: toastStyle(),
                });
              };
            },
          });
        }, "image/pngs");
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      getRestoLogin(),
      "Item History"
    );
    if (response.data) {
      setAllowPrint(false);
      setAllowPrint(false);
      refreshPage();
    } else {
      setAllowPrint(false);
    }
  }

  // useEffect(() => {
  //   if (allowPrint === true) {
  //     handleGeneratePrint()
  //   }
  // }, [allowPrint])

  useEffect(() => {
    fetchSales();
  }, [filter]);

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col>
            <h1 className="page-title-menu"> ITEM HISTORY REPORT</h1>
          </Col>
          <Col className="">
            {itemHistory.length > 0 && (
              <Row className="">
                <Col className="d-flex justify-content-end">
                  <button
                    className="category-new-export-btn"
                    // onClick={handlePrint}
                    onClick={handleGeneratePrint}
                  >
                    PRINT
                  </button>
                </Col>
                {(getRole() === "1" || getRole() === "7") && (
                  <Col className="d-flex justify-content-end">
                    {handlePDF()}
                  </Col>
                )}
                <Col>{handleToCSV()}</Col>
              </Row>
            )}
          </Col>
        </Row>
        <hr />
        <div className="table-content">
          <div className="my-2 px-4 PO-filters d-flex">
            {getRole() !== 2 && (
              <>
                {/* <span className="me-1 align-middle mt-2">FILTER</span>
                <span className="me-1 align-middle mt-2">BY</span>
                <span className="me-3 align-middle mt-2">DATE:</span> */}
                <span className="me-2 align-middle mt-2">FROM:</span>
                <Form.Control
                  size="sm"
                  type="date"
                  name="date_from"
                  className="date-filter me-3"
                  onChange={handleFilter}
                  value={filter.date_from}
                />
                <span className="me-2 align-middle mt-2">TO:</span>
                <Form.Control
                  size="sm"
                  type="date"
                  name="date_to"
                  className="date-filter me-3"
                  onChange={handleFilter}
                  value={filter.date_to}
                />
                <span className="me-4 align-middle mt-2">PERFORMANCE:</span>
                <Form.Select
                  size="sm"
                  name="performing"
                  className="date-filter me-3"
                  onChange={handleFilter}
                >
                  <option value="" hidden selected>
                    Select Performance
                  </option>
                  <option value={""}>All</option>
                  <option value={"worst"}>Worst (20)</option>
                  <option value={"top"}>Top (20)</option>
                </Form.Select>
              </>
            )}
          </div>
          {/* TABLE */}
          <Table
            tableHeaders={["ITEM NAME", "COUNT"]}
            headerSelector={["menu_name", "count"]}
            tableData={itemHistory}
            showLoader={showLoader}
          />
        </div>

        <div style={{ display: "none" }}>
          <PrintReportReceipts
            ref={componentRefSummary}
            name={"Item History Report"}
            data={exportData}
            filter={filter}
          />
        </div>
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_name}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_address}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {" "}
                  {window.company_vat_reg_tin}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_min}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_sn}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_ptu_no}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.issued_date}
                </label>
              </div>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>ITEM HISTORY REPORTS</th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE FROM: {dateFormat(new Date(filter.date_from))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE TO: {dateFormat(new Date(filter.date_to))}
                    </th>
                  </tr>
                  <tr>
                    <th>MENU</th>
                    <th>QTY</th>
                    <th>PRICE</th>
                    <th>TOTAL</th>
                  </tr>
                  {itemHistory.map((data) => {
                    return (
                      <tr>
                        <td>{data.menu_name} </td>
                        <td>{data.count}</td>
                        <td>
                          {numberFormat(parseFloat(data.price).toFixed(2))}{" "}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.total).toFixed(2))}{" "}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td> {numberFormat(parseFloat(priceTotal).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(grandTotal).toFixed(2))}</td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
              <div className="d-flex row justify-content-center mt-2">
                <label className="d-flex row justify-content-center print-text">
                  {window.myt_name}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  301 THE GREENERY, POPE JOHN PAUL II AVE.,
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.myt_address1}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {" "}
                  {window.myt_vat_reg_tin}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.myt_acc_no}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.myt_issued_date}
                </label>
              </div>
            </div>
          </Row>
        </div>
        {/* {allowPrint && ( */}
        <div className="hide-from-screen">
          <div ref={divId}>
            <div className="d-flex justify-content-center">
              <div className="print-receipt">
                <Row className="">{window.company_name}</Row>
                <Row className="smaller-text">{window.company_address}</Row>
                <Row className="">{window.company_vat_reg_tin}</Row>
                <Row className="">{window.company_min}</Row>
                <Row className="">{window.company_sn}</Row>
                <Row className="smaller-text">{window.company_ptu_no}</Row>
                <Row className="">{window.company_issued_date}</Row>
                <div className="d-flex row justify-content-left">
                  <label className="d-flex row justify-content-left print-text print-text">
                    <strong>
                      {filter.performing === ""
                        ? "Item History - All"
                        : filter.performing === "top"
                        ? "Item History - Top"
                        : "Item History - Worst"}
                    </strong>
                  </label>
                </div>
                <div className="d-flex row justify-content-left">
                  <label className="d-flex row justify-content-left print-text">
                    DATE FROM: {dateFormat(new Date(filter.date_from))}
                  </label>
                </div>
                <div className="d-flex row justify-content-left">
                  <label className="d-flex row justify-content-left print-text">
                    DATE TO: {dateFormat(new Date(filter.date_to))}
                  </label>
                </div>
                <hr />
                <div className="row mt-1">
                  <div className="col-10 print-text">
                    <label>
                      <strong>MENU</strong>
                    </label>
                  </div>
                  <div className="col-2 d-flex justify-content-end print-text">
                    <label>
                      <strong>QTY</strong>
                    </label>
                  </div>
                </div>
                {itemHistory.map((data) => {
                  return (
                    <div className="row">
                      <div className="col-10 print-text">
                        <label>
                          <strong>{data.menu_name}</strong>
                        </label>
                      </div>
                      <div className="col-2 d-flex justify-content-end print-text">
                        <label>
                          <strong>{data.count}</strong>
                        </label>
                      </div>
                    </div>
                  );
                })}
                <Row className="mt-4">{window.myt_name}</Row>
                <Row className="smaller-text">{window.myt_address1}</Row>
                <Row className="">{window.myt_address2}</Row>
                <Row className="">{window.myt_vat_reg_tin}</Row>
                <Row className="">{window.myt_min}</Row>
                <Row className="">{window.myt_sn}</Row>
                <Row className="">{window.myt_ptu_no}</Row>
                <Row className="">{window.myt_issued_date}</Row>
                <Row>.............................</Row>
                <Row>.............................</Row>
                <Row>.............................</Row>
              </div>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
      <div>
        <label className="powered-label text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}

export default ItemHistory;
